import React, { useState, useEffect } from 'react';
import './Dashboard.css';

const Messages = () => {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [sidebarClosed, setSidebarClosed] = useState(false);

    // Fetch messages from API
    useEffect(() => {
        fetchMessages();
    }, []);

    const fetchMessages = async () => {
        try {
            setLoading(true);
            const response = await fetch("https://alaussback-production.up.railway.app/api/contacts/read");
            
            if (!response.ok) {
                throw new Error("Failed to fetch messages");
            }
            
            const data = await response.json();
            setMessages(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const toggleSidebar = () => {
        setSidebarClosed(!sidebarClosed);
    };

    return (
        <div className="dashboard">
      
            {/* Main Content */}
            <div className="main-content">
         

                {/* Main Content Area */}
                <main className="content">
                    <div className="dashboard-sections">
                        <div className="recent-orders">
                            <h3>رسائل التواصل</h3>

                            {/* Error Message */}
                            {error && (
                                <p style={{ color: 'red' }}>
                                    خطأ: {error}
                                </p>
                            )}

                            {/* Loading State */}
                            {loading ? (
                                <p>جارٍ تحميل الرسائل...</p>
                            ) : (
                                <div className="table-container">
                                    {messages.length === 0 ? (
                                        <p>لا توجد رسائل.</p>
                                    ) : (
                                        <>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>الرقم</th>
                                                        <th>الاسم</th>
                                                        <th>البريد الإلكتروني</th>
                                                        <th>الرسالة</th>
                                                        <th>التاريخ</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {messages.map((message) => (
                                                        <tr key={message.id}>
                                                            <td>{message.id}</td>
                                                            <td>{message.name}</td>
                                                            <td>
                                                                <a href={`mailto:${message.email}`}>
                                                                    {message.email}
                                                                </a>
                                                            </td>
                                                            <td style={{ maxWidth: '300px', wordWrap: 'break-word' }}>
                                                                {message.message}
                                                            </td>
                                                            <td>
                                                                {message.createdAt || message.date || 'غير محدد'}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            <p style={{ marginTop: '1rem', textAlign: 'center' }}>
                                                إجمالي الرسائل: {messages.length}
                                            </p>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Messages;